import styles from './PageContainer.module.scss'
import type { PageContainerProps } from './types'

/**
 * PageContainer — contenedor estándar del Design System (Entradas).
 *
 * Componente presentacional (Server Component). Aplica automáticamente el
 * padding lateral correcto por breakpoint y el max-width en XXL (≥ 1920px)
 * mediante el mixin `page-gutter`.
 *
 * Usar como wrapper del contenido interior de cualquier sección. NO usar en
 * secciones edge-to-edge (Hero, banners full-width, overlays).
 */
export function PageContainer({ children, className, id, as: Tag = 'div' }: PageContainerProps) {
  const containerClassName = className ? `${styles.container} ${className}` : styles.container

  return (
    <Tag id={id} className={containerClassName}>
      {children}
    </Tag>
  )
}
